import React from "react";
import "../Privacy_Policy/Privacy_Policy.css";

export default function Privacy_Policy() {
  const informationUsage = [
    "לצורך מתן מענה לפניות המתקבלות דרך האתר ובאמצעי הקשר המוצגים בו.",
    "לצורך יצירת קשר עם משתמשים לצורך קבלת הצעת מחיר, תיאום שירות או המשך טיפול בפנייה.",
    "לצורך מתן שירותי הובלה, מנופים, הרמה והובלת ציוד, בהתאם לפנייה ולשירות המבוקש.",
    "לצורך שיפור, תפעול ופיתוח האתר וחוויית המשתמש.",
    "לצורך ניתוח נתונים סטטיסטיים בנוגע לשימוש באתר, במטרה לשפר את השירותים והתוכן המוצעים בו.",
    "לצורך שמירת תיעוד של פניות, בקשות, הצעות מחיר ושירות לקוחות.",
    "לצורך משלוח מידע שיווקי או פרסומי, בכפוף להוראות הדין ולהסכמות הנדרשות.",
    "לצורך עמידה בדרישות הדין, מניעת שימוש לרעה באתר והגנה על זכויות החברה."
  ];

  const collectedInformation = [
    "שם פרטי ומשפחה.",
    "מספר טלפון ופרטי קשר.",
    'כתובת דוא"ל, ככל שנמסרה.',
    "פרטי הפנייה שהמשתמש בחר למסור באמצעות האתר.",
    "פרטים הנדרשים לצורך קבלת הצעת מחיר או תיאום שירות.",
    "מידע טכני וסטטיסטי אודות השימוש באתר, כגון סוג מכשיר, דפדפן, כתובת IP ודפים שנצפו.",
    "מידע נוסף שהמשתמש בוחר למסור לנו מרצונו."
  ];

  const informationUse = [
    "טיפול בפניות ומתן מענה ללקוחות ולמתעניינים.",
    "יצירת קשר לצורך מתן הצעת מחיר, תיאום שירות או המשך טיפול.",
    "שיפור השירותים, האתר וחוויית המשתמש.",
    "שמירת תיעוד של פניות ושירותים שניתנו.",
    "שליחת מידע שיווקי או הצעות, כאשר הדבר מותר על פי דין ובהתאם להסכמות שניתנו.",
    "אבטחת האתר, מניעת שימוש לרעה, איתור תקלות ושמירה על תקינות המערכות.",
    'עמידה בדרישות הדין והגנה על זכויותיה של נצר הובלות ומנופים בע"מ.'
  ];

  const renderList = (items) => {
    return items.map((text, index) => (
      <div
        key={index}
        style={{
          position: "relative",
          paddingRight: "20px",
          marginBottom: "12px"
        }}
      >
        <span
          style={{
            position: "absolute",
            right: "0",
            top: "0",
            fontSize: "16px",
            fontWeight: "bold"
          }}
        >
          •
        </span>

        <p style={{ margin: "0" }}>
          {text}
        </p>
      </div>
    ));
  };

  return (
    <div className="Privacy_Policy-page">

      <div className="Privacy_Policy-hero">
        <div className="Privacy_Policy-overlay">
          <h1>מדיניות פרטיות</h1>
        </div>

        <div></div>
      </div>

      {/* CONTENT */}
      <div className="page3">
        <div className="container">

          <h2 className="top-text">
            כללי
          </h2>

          <div className="content-row">

            <div className="text-box">
              <p>
                אנו באתר נצר הובלות ומנופים בע"מ מכבדים את פרטיותם של
                משתמשי האתר. מטרתה של מדיניות פרטיות זו היא להבהיר לגולש
                את מדיניות הפרטיות הנהוגה באתר, לרבות אופן איסוף המידע,
                השימוש בו והמטרות שלשמן הוא עשוי להיאסף ולהישמר.
              </p>

              <p>
                השימוש באתר ובשירותים המוצעים באמצעותו כפוף למדיניות
                פרטיות זו ולהוראות כל דין.
              </p>
            </div>

          </div>

          <h2 className="main-title">
            שינויים במדיניות הפרטיות
          </h2>

          <div className="bottom-text">
            <p>
              מפעילי האתר רשאים לעדכן ולשנות מעת לעת את מדיניות הפרטיות.
              במקרה של שינוי מהותי במדיניות הנוגע לשימוש במידע אישי,
              רשאית החברה לפרסם הודעה מתאימה באתר. הנוסח המעודכן של
              מדיניות הפרטיות יהיה הנוסח המחייב מרגע פרסומו באתר.
            </p>
          </div>

          <h2 className="main-title">
            שימוש במידע
          </h2>

          <div className="bottom-text">

            <p>
              מידע שנמסר לנו או שנאסף במסגרת השימוש באתר עשוי לשמש,
              בין היתר, למטרות הבאות:
            </p>

            <div
              style={{
                direction: "rtl",
                textAlign: "right",
                fontFamily: "Arial, sans-serif",
                color: "#1a1a1a",
                fontSize: "14px",
                lineHeight: "1.6",
                maxWidth: "800px",
                margin: "20px auto",
                padding: "0 15px"
              }}
            >
              {renderList(informationUsage)}
            </div>

          </div>

          <h2 className="main-title">
            עוגיות
          </h2>

          <div className="bottom-text">

            <p>
              קובץ Cookie הוא קובץ קטן אשר עשוי להישמר במחשב, בטלפון או
              במכשיר אחר של המשתמש. קבצי Cookies עשויים לשמש לצורך תפעולו
              התקין של האתר, שמירת העדפות, שיפור חוויית המשתמש ואיסוף מידע
              סטטיסטי אודות השימוש באתר.
            </p>

            <p>
              האתר עשוי להשתמש בשירותי סטטיסטיקה וניתוח וכן בשירותים של
              צדדים שלישיים, אשר עשויים להשתמש בקובצי Cookies בהתאם
              למדיניות הפרטיות שלהם.
            </p>

            <p>
              המשתמש יכול לבחור אם לאפשר או לדחות קבצי Cookie באמצעות
              הגדרות הדפדפן שלו. חסימת Cookies מסוימים עלולה להשפיע על
              פעילותם התקינה של חלק מהפונקציות באתר.
            </p>

          </div>

          <h2 className="main-title">
            מה אנו אוספים
          </h2>

          <div className="bottom-text">

            <p>
              אנו עשויים לאסוף את המידע הבא, בהתאם לאופן השימוש באתר:
            </p>

            <div
              style={{
                direction: "rtl",
                textAlign: "right",
                fontFamily: "Arial, sans-serif",
                color: "#1a1a1a",
                fontSize: "14px",
                lineHeight: "1.6",
                maxWidth: "800px",
                margin: "20px auto",
                padding: "0 15px"
              }}
            >
              {renderList(collectedInformation)}
            </div>

          </div>

          <h2 className="main-title">
            מה אנחנו עושים עם המידע שאנו אוספים
          </h2>

          <div className="bottom-text">

            <p>
              אנו עשויים להשתמש במידע שנאסף לצורך מתן שירות יעיל,
              טיפול בפניות, שיפור האתר והשירותים שלנו ובמקרים המתאימים
              לצורך יצירת קשר עם המשתמש.
            </p>

            <div
              style={{
                direction: "rtl",
                textAlign: "right",
                fontFamily: "Arial, sans-serif",
                color: "#1a1a1a",
                fontSize: "14px",
                lineHeight: "1.6",
                maxWidth: "800px",
                margin: "20px auto",
                padding: "0 15px"
              }}
            >
              {renderList(informationUse)}
            </div>

          </div>

          <h2 className="main-title">
            אבטחת מידע
          </h2>

          <div className="bottom-text">
            <p>
              אנו נוקטים באמצעים סבירים ומקובלים במטרה להגן על המידע
              הנמצא בשליטתנו מפני גישה בלתי מורשית, שימוש לרעה, אובדן
              או שינוי. עם זאת, אין מערכת מידע או העברת מידע באינטרנט
              שניתן להבטיח כי תהיה מוגנת לחלוטין מפני חדירה או גישה
              בלתי מורשית.
            </p>
          </div>

          <h2 className="main-title">
            פרסומות באתר
          </h2>

          <div className="bottom-text">
            <p>
              האתר עשוי להציג תכנים, פרסומות או שירותים של צדדים שלישיים.
              צדדים שלישיים אלה עשויים להשתמש בטכנולוגיות שונות, לרבות
              Cookies, לצורך מדידה, ניתוח, התאמת פרסום או הצגת תוכן,
              בהתאם למדיניות הפרטיות שלהם.
            </p>
          </div>

          <h2 className="main-title">
            מסירת מידע לצדדים שלישיים
          </h2>

          <div className="bottom-text">
            <p>
              אנו לא נמכור או נשכיר מידע אישי של משתמשי האתר לצדדים
              שלישיים. עם זאת, ייתכן שמידע יועבר לספקי שירות או לגורמים
              הפועלים מטעמנו, ככל שהדבר נדרש לצורך תפעול האתר, מתן שירות,
              תחזוקת מערכות, אבטחה, ניתוח נתונים או עמידה בדרישות הדין.
            </p>
          </div>

          <h2 className="main-title">
            חוק הגנת הפרטיות
          </h2>

          <div className="bottom-text">

            <p>
              מדיניות זו נועדה להסדיר את אופן הטיפול במידע בהתאם להוראות
              הדין הרלוונטיות, לרבות הוראות חוק הגנת הפרטיות, התשמ"א–1981,
              והתקנות מכוחו, ככל שהן חלות על פעילות האתר והחברה.
            </p>

            <p>
              במהלך השימוש באתר עשוי להיאסף מידע אודות המשתמש, אופן השימוש
              באתר, השירותים שבהם התעניין ופרטים נוספים שהמשתמש בחר למסור.
              המשתמש אינו חייב למסור מידע אישי בכל מקרה, אולם במקרים
              מסוימים מסירת מידע עשויה להיות נחוצה לצורך קבלת שירות,
              יצירת קשר, קבלת הצעת מחיר או טיפול בפנייה.
            </p>

          </div>

          <h2 className="main-title">
            זכויות המשתמש
          </h2>

          <div className="bottom-text">

            <p>
              ככל שהדבר חל ובהתאם להוראות הדין, המשתמש רשאי לפנות אלינו
              בנוגע למידע שנמסר על ידו ולבקש לעיין במידע, לתקן מידע שאינו
              נכון או לעדכן פרטים שנמסרו.
            </p>

            <p>
              ניתן לפנות באמצעות פרטי הקשר המופיעים באתר.
            </p>

          </div>

          <h2 className="main-title">
            יצירת קשר
          </h2>

          <div className="bottom-text">

            <p>
              בכל שאלה הנוגעת למדיניות הפרטיות, לאופן השימוש במידע או
              לנושאי פרטיות באתר, ניתן לפנות אל נצר הובלות ומנופים בע"מ
              באמצעות פרטי הקשר המופיעים באתר.
            </p>

          </div>

        </div>
      </div>
    </div>
  );
}
